import { OrganizationState } from '../models';

export const defaultOrganization: OrganizationState = {
  organization: {
    id: '',
    name: '',
    jsondata: {
      billing: {},
      applicationIds: [],
    },
    mediaUsageMs: null,
  },
};
